import { get } from 'lodash';
import isADentistrySpecialty from '../../../utils/isADentistrySpecialty';
import { NonDoctorOrDentistSpecialties } from '../../../constants';

// This function returns either "Doctor", "Dentist", or 'Professional" given the specialty type
// of the profile (see NewExistingRadioLabel)

export const PROFILE_LABELS = {
    Dentist: 'dentist',
    Doctor: 'doctor',
    Professional: 'professional',
};

export default function getProfileLabelType(provider) {
    const specialtyId = get(provider, 'relevantSpecialty.id');
    if (isADentistrySpecialty(specialtyId)) {
        return PROFILE_LABELS.Dentist;
    } else if (NonDoctorOrDentistSpecialties.has(specialtyId)) {
        return PROFILE_LABELS.Professional;
    }
    return PROFILE_LABELS.Doctor;
}
